import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=abf8ad38&scoped=true&"
import script from "./Topics.vue?vue&type=script&lang=js&"
export * from "./Topics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf8ad38",
  null
  
)

export default component.exports